import React from 'react';
import { product } from '../data/ebook';
import { Section } from './Section';
export function Method() {
  return <Section id="metodo" className="bg-sage-light" data-id="element-155" data-mp="71u76n81grgk">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-156" data-mp="74q1m1kogy09">
        <img src={product.protocolImage} alt="Caldo de vegetales con jengibre, apio y piña fresca sobre mármol blanco" className="w-full rounded-lg object-cover" width={1200} height={800} data-id="element-157" data-mp="c2rkomi3sxbq" />

        <div data-id="element-158" data-mp="3kh8nfepd6fbe">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-159" data-mp="3kitgt0zxzs7o">
            El método
          </p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight text-ink sm:text-5xl" data-id="element-160" data-mp="3pfa1tmbuhqgj">
            El Protocolo de Vacío Intestinal
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-161" data-mp="2wsz5inv9ubpj">
            No se trata de pasar hambre. Se trata de <strong className="font-semibold text-ink" data-id="element-162" data-mp="31qim3uffz0kn">drenaje
            digestivo</strong>: alimentos que actúan como imanes para el exceso de agua y técnicas
            físicas que mueven los desechos estancados.
          </p>

          <div className="mt-8 space-y-5 border-t border-sand pt-8" data-id="element-163" data-mp="kh3i4lpe7x3e">
            <p className="text-[15px] leading-relaxed text-muted" data-id="element-164" data-mp="fojtmtp63hjt">
              <span className="font-semibold text-ink" data-id="element-165" data-mp="bo9nnh1dkr4y">Día 1 — Choque Enzimático.</span> Caldo de
              Oro con jengibre y piña fresca. La bromelina rompe las proteínas atrapadas que causan
              gas y putrefacción.
            </p>
            <p className="text-[15px] leading-relaxed text-muted" data-id="element-166" data-mp="1p28cob2ymf7">
              <span className="font-semibold text-ink" data-id="element-167" data-mp="3svljy5oqqgek">Días 2 al 7 — Menú de Emergencia.</span>{' '}
              Comidas resueltas, hidratación osmótica, masaje de drenaje de 5 minutos y sueño
              digestivo.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}